import React from 'react'

import { PostSidebar } from './PostSidebar'

export const PostLayout = ({ post, isNote, children }) => {
  const toc = post.tableOfContents

  return (
    <>
      <main className="main-content">{children}</main>
      {toc && !isNote && <PostSidebar toc={toc} />}
    </>
  )
}
